import { render, staticRenderFns } from "./editSocialContact.vue?vue&type=template&id=7ac76418&"
import script from "./editSocialContact.vue?vue&type=script&lang=js&"
export * from "./editSocialContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports